import {
  IDocumentMediaPreviewData,
  IOrganizationUser,
  MESSAGE_CONTENT_TYPE,
} from "@home-health-notify/domain";
import { isBlobImage } from "../../utils/MessageUtils";

export const getMediaUrl = (
  activeMedia: IDocumentMediaPreviewData,
): string | null => {
  if (
    !activeMedia.media ||
    activeMedia.media.length === 0 ||
    !activeMedia.media[0].url
  ) {
    return null;
  }
  switch (activeMedia.mediaType) {
    case MESSAGE_CONTENT_TYPE.VOICE:
    case MESSAGE_CONTENT_TYPE.IMAGE:
    case MESSAGE_CONTENT_TYPE.VIDEO:
    case MESSAGE_CONTENT_TYPE.DOCUMENT:
      return activeMedia.media[0].url;
    default:
      return null;
  }
};

export const getBlobUrl = async (
  activeMedia: IDocumentMediaPreviewData,
  selectedOrgUser: IOrganizationUser,
): Promise<string> => {
  try {
    const url = getMediaUrl(activeMedia);
    if (!url) {
      throw new Error("No media url found");
    }
    if (isBlobImage(url)) {
      return url;
    }
    const signedUrlInfo = await selectedOrgUser.assetManager.getSignedUrlInfo(
      url,
      true,
    );
    if (!signedUrlInfo?.signedUrl) {
      throw new Error("No signed url found");
    }
    const response = await fetch(signedUrlInfo.signedUrl);
    const blobImage = await response.blob();
    return URL.createObjectURL(blobImage);
  } catch (e) {
    throw e;
  }
};

export const printDocument = (docUrl: string) => {
  window.open(docUrl, "_blank");
};
export const printImage = (mediaUrl: string) => {
  const printWindow = window.open(mediaUrl, "", "width=1900,height=1600");
  if (printWindow && printWindow.document) {
    printWindow.document.open();
    printWindow.document.write(
      "<html><head><title></title><script>function openPrint() { window.print();\n" +
        "        window.close(); }</script></head><body>",
    );
    printWindow.document.write(
      '<img src="' +
        mediaUrl +
        '" style="max-width:100%;" onload="openPrint()"  alt="img"/>',
    );
    printWindow.document.write("</body></html>");
    printWindow.document.close();
  }
};
